import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import PropTypes from 'prop-types';
import { useAppointmentDetailsContext } from '../contexts/appointmentdetails.context';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import Spinner from '../../../../components/spinner/spinner';
import { APIUtils } from '../../../../utils/apiutils';
import { objectToFormData } from '../../../../utils/utils';
import httpClient from '../../../../services/http';
import Swal from 'sweetalert2';
import { CUSTOM_EVENTS, USER_ROLES } from '../../../../utils/constants';
import { useSelector } from 'react-redux';

const UploadReportDialog = ({toggleUploadReport}) => {
    const { appointmentDetails } = useAppointmentDetailsContext();
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false);

    const handlePrescription = (e) => {
        const fileData = e.target.files[0];
        setFile(fileData);
    };

    const handleUploadReport = async () => {
        const url = APIUtils.getAPIEndpoint('myappointment-upload-report');
        const filename = file.name.replace(/\.[^/.]+$/, '').replace(/[^a-zA-Z0-9\s]/g, '');
        const formData = objectToFormData({ report: file, name: filename, apptID: appointmentDetails.id });
        setUploading(true);
        const res = await httpClient.post(url, formData).then(res => res.data);
        if (res.status === 'success') {
            Swal.fire('Status!', 'Report uploaded successfully!', 'success');
            // Close upload report dialog
            toggleUploadReport(false)();
            // Fetch reports list
            document.dispatchEvent(new CustomEvent(CUSTOM_EVENTS.REFECTH_REPORTS));
        } else {
            Swal.fire('Something Went Wrong!', '', 'error');
        }
        setUploading(false);
    };

    const selectedFileName = file && file.name;

    const uploadBtn = (
        <>
            <div className='flex-gap'>
                <Button variant='outlined' component='label'>
                    <input
                        type='file'
                        accept='image/png, application/pdf, image/jpeg'
                        hidden={true}
                        onChange={handlePrescription}
                    />
                    Browse Report
                </Button>
                <p className='text-ellipsis' title={selectedFileName}>{selectedFileName}</p>
            </div>
            <Divider>OR</Divider>
            <div className='flex-gap'>
                <Button variant='outlined' component='label'>
                    <input
                        type='file'
                        accept="image/*"
                        capture="environment"
                        hidden={true}
                        onChange={handlePrescription}
                    />
                    Capture Photo (Mobile Only)
                </Button>
                <p className='text-ellipsis' title={selectedFileName}>{selectedFileName}</p>
            </div>
        </>
    );

    const uploadingUI = () => {
        if (uploading) {
            return (
                <>
                    Uploading...&nbsp;<Spinner />
                </>
            );
        }
        return <>Upload</>;
    };

    const btnDisabled = !file || uploading;

    return  <>
        {uploadBtn}
        <DialogActions>
            <Button variant='contained' color='primary' disabled={btnDisabled} onClick={handleUploadReport}>
                {uploadingUI()}
            </Button>
        </DialogActions>
    </>;
};

const UploadReport = () => {
    const userInfo = useSelector(state => state.auth.user);
    const [openUploadReport, setOpenUploadReport] = useState(false);

    const toggleUploadReport = (toggle) => () => {
        setOpenUploadReport(toggle);
    };

    const reportDialog = openUploadReport && (
        <Dialog open={openUploadReport} maxWidth='xs' fullWidth>
            <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ flex: 1 }}>Upload Report</div>
                <IconButton size='small' onClick={toggleUploadReport(false)}>
                    <CloseOutlinedIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <UploadReportDialog toggleUploadReport={toggleUploadReport} />
            </DialogContent>
        </Dialog>
    );

    const addTestReportBtn = userInfo && userInfo.role && userInfo.role === USER_ROLES.PATIENT && <Button color="primary" variant="contained" onClick={toggleUploadReport(true)}> <AddIcon />&nbsp;Add Test Reports </Button>;

    return (
        <>
            {reportDialog}
            {addTestReportBtn}
        </>
    );
};

export default UploadReport;

UploadReportDialog.propTypes = {
    toggleUploadReport: PropTypes.func.isRequired,
};